import { NeoModel, ModelBase } from '@singularsystems/neo-core';
@NeoModel
export default class StaticEntityTaxLookup extends ModelBase {

    /// <summary>
    /// Gets or sets the entity tax ID.
    /// </summary>
    public entityTaxId: number = 0;

    /// <summary>
    /// Gets or sets the tax rate.
    /// </summary>
    public taxRate : number = 0;

    /// <summary>
    /// Gets or sets the tax Id.
    /// </summary>
    public taxId : number = 0;

    /// <summary>
    /// Gets or sets the client entity type name.
    /// </summary>
    public clientEntityTypeName : string = "";
    
    /// <summary>
    /// Gets or sets the client entity type ID.
    /// </summary>
    public clientEntityTypeId : number = 0;    
    
    /// <summary>
    /// Gets or sets the tax Type Description.
    /// </summary>
    public taxTypeDescription : string = "";

    /// <summary>
    /// Gets or sets the effective start date.
    /// </summary>
    public effectiveStartDate : Date | null = null;
}